<template>
  <div class="method-options-card-header">
    <div
      class="method-options-card-header__icon"
      :style="logoStyles(method)"
    />
    <div
      v-if="!isOnlyOneService"
      class="method-options-card-header__description"
    >
      <h5>{{ $t('chose_preferred_currency') }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    method: {
      type: Object
    },
    isOnlyOneService: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    logoStyles(method) {
      return {
        "min-height": "5em",
        "background-image": `url(${method.logo})`,
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "contain"
      };
    }
  }
};
</script>

<style>
</style>
